module.exports = __webpack_public_path__ + "img/creditCard.ab232ac6.png";